export default {
  init() {
    // JavaScript to be fired on all pages

    const navExpand = [].slice.call(document.querySelectorAll('.nav-expand'))
    const backLink = `<li class="nav-item">
      <a class="nav-link nav-back-link" href="javascript:;">
        Terug
      </a>
    </li>`

    navExpand.forEach(item => {
      item.querySelector('.nav-expand-content').insertAdjacentHTML('afterbegin', backLink)
      item.querySelector('.nav-link').addEventListener('click', () => item.classList.add('active'))
      item.querySelector('.nav-back-link').addEventListener('click', () => item.classList.remove('active'))
    })


    // ---------------------------------------
    // not-so-important stuff starts here

    const ham = document.getElementById('ham')
    ham.addEventListener('click', function() {
      // 1. Toggle class in de body naar "nav is toggled"
      document.body.classList.toggle('nav-is-toggled');

      // 2. kijk of de toggle aan of uit staat:
      var navToggle = document.querySelector('body');
      // zet de aria-expanded op true/false om accessibility redenen
      if(navToggle.classList.contains('nav-is-toggled')) {
        this.setAttribute('aria-expanded', true);
      } else {
        this.setAttribute('aria-expanded', false);
      }
    })

    $(function () {
      $('[data-toggle="popover"]').popover().click(function( event ) {
        event.preventDefault();

        if (this.firstElementChild.alt == 'toon korte samenvatting') {
          this.firstElementChild.setAttribute('alt','sluit korte samenvatting');
        } else {
          this.firstElementChild.setAttribute('alt','toon korte samenvatting');
        }
      });
    })

    $('.socials a').click(function() {
      event.preventDefault();

      var href = $(this).attr('href');
      var title = $(this).attr('title');
      window.open(href,title,'scrollbars=yes,width=650,height=500');
       // alert(this);
    });

    $('.search_icon').click(function( event ) {
      event.preventDefault();
      
      $( '#search' ).addClass( 'active' );
      $ ('#search').attr('aria-expanded', true)
      $( '.search-field' ).focus();

    });

    $('#close').click(function() {
      $( '#search' ).removeClass( 'active' );
      $ ('#search').attr('aria-expanded', false)
    });

    $(document).on('keyup', function(event) {
      var search = document.getElementById('search');

      if(event.key == 'Escape' && search.classList.contains('active')) {
        search.classList.remove('active');
      }
    });

    //Search form

    $('#site-search').keyup(delay(function () {
      //console.log('Time elapsed!', this.value);

      var $onderwerpen = $('.onderwerp input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
      var $aanvragers = $('.aanvrager input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
      var $gezag = $('.gezag input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
      var $s = this.value;
      
      var $number = $('.ajax_content').attr('data-number');


      //ajax call
      actionAjax($number, $onderwerpen, $aanvragers, $gezag, $s, 'dev_load_project');

    }, 500));

    $('#searchform').submit(function(e) {
      e.preventDefault();
    });


    function delay(callback, ms) {
      var timer = 0;
      return function() {
        var context = this, args = arguments;

        //kijken of het veld net leeg is gegooid
        if ($(this).val() == '') { 

          //vul dan de lege waarden in 
          var $onderwerpen = $('.onderwerp input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
          var $aanvragers = $('.aanvrager input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
          var $gezag = $('.gezag input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
          var $s =  $('#site-search').val(); 
    
          var $number = $('.ajax_content').attr('data-number');
          //ajax call
          actionAjax($number, $onderwerpen, $aanvragers, $gezag, $s, 'dev_load_project');
          
        }
        //anders vertraagd reageren
        clearTimeout(timer);
        timer = setTimeout(function () {
          callback.apply(context, args);
        }, ms || 0);
      };
    }

    // click to search forms
    $('input[type="checkbox"]').change(function () {
     
      // haal bij elke verandering van een checkbox, alle aangevinkte items op
      //Dat moet dus per categorie worden gedaan en doorgegeven aan de AJAX call

      var $onderwerpen = $('.onderwerp input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
      var $aanvragers = $('.aanvrager input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
      var $gezag = $('.gezag input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
      var $s =  $('#site-search').val(); 

      var $number = $('.ajax_content').attr('data-number');
      //ajax call
      actionAjax($number, $onderwerpen, $aanvragers, $gezag, $s, 'dev_load_project');
  });

  function actionAjax($number = -1, $onderwerpen = '', $aanvragers = '', $gezag = '', $s = '', $action = '', $page = 1) {
      const ajax_url = window.dev_ajax.ajax_url || false;
      // console.log($onderwerpen);
      if (ajax_url) {
          $.ajax({
              method: 'POST',
              url: ajax_url,
              data: {number: $number, onderwerp : $onderwerpen, aanvrager : $aanvragers, gezag : $gezag, action: $action, s: $s, page: $page},
              beforeSend: function() {
                  $('#loading').show();
              },
              success: function (result) {
                  $('.lijst').html(result);
                  $('#loading').hide();
                  scrollToTop();
                  popOver();
              },
          });
      }

      function scrollToTop() {
        var body = $('html, body');
        body.stop().animate({scrollTop: ($('.lijst').offset().top-250)}, 400, 'swing');
    }

      function popOver() {
        $('[data-toggle="popover"]').popover().click(function( event ) {
          event.preventDefault();
          if (this.firstElementChild.alt == 'toon korte samenvatting') {
            this.firstElementChild.setAttribute('alt','sluit korte samenvatting');
          } else {
            this.firstElementChild.setAttribute('alt','toon korte samenvatting');
          }
        });
    }

  }
 
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/formulier.js